let timer = null;
function debounce(func, delay) {
  if (timer) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func();
    }, delay);
  } else {
    timer = setTimeout(() => {
      func();
    }, delay);
  }
}
export {debounce};
